import { AuditActivityActionSchema, type AuditQuery } from "../../shared/audit-schemas";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export function AuditActivityFilters({
  query,
  onChange,
}: {
  query: AuditQuery;
  onChange: (query: AuditQuery) => void;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {(["application", "person", "record"] as const).map((key) => (
        <div key={key} className="grid gap-2">
          <Label htmlFor={`audit-${key}`}>
            {key === "application"
              ? "Application"
              : key === "person"
                ? "Person"
                : "Record reference"}
          </Label>
          <Input
            id={`audit-${key}`}
            name={key}
            defaultValue={query[key] ?? ""}
            key={query[key] ?? ""}
            maxLength={key === "record" ? 128 : 120}
            placeholder={key === "record" ? "Exact reference, e.g. D-023" : "Name or ID"}
          />
        </div>
      ))}
      <div className="grid gap-2">
        <Label htmlFor="audit-action">Action</Label>
        <select
          id="audit-action"
          className="min-h-10 rounded-sm border border-input bg-card px-3 text-sm outline-none focus-visible:ring-2 focus-visible:ring-primary"
          value={query.action ?? "all"}
          onChange={(event) => {
            onChange({
              ...query,
              action:
                event.currentTarget.value === "all"
                  ? undefined
                  : AuditActivityActionSchema.parse(event.currentTarget.value),
            });
          }}
        >
          <option value="all">All actions</option>
          {AuditActivityActionSchema.options.map((action) => (
            <option key={action} value={action}>
              {action.charAt(0).toUpperCase() + action.slice(1)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
